$(() => {
	// home banner background video
	let homeBannerBackgroundVideo = $('.bs-section--main-banner-mobile .bs-section__video > video');
	let homeBanner = $('.bs-section--main-banner-mobile');
	if (homeBanner.length && homeBannerBackgroundVideo.attr('autoplay')) {
		homeBannerBackgroundVideo.attr('playsinline','')
	}
});